import React from 'react';

import styles from './style.module.css';
import {
    HouseIcon,
    ChairIcon,
    LampIcon,
    PaintRollerIcon,
    PuzzlePieceIcon,
    ChatCircleDotsIcon,
    WallIcon,
} from '@phosphor-icons/react';
import {NavItem} from '@/components/layout/navigation/nav-item';
import {useMaterialsAccess} from '@/hooks/useMaterialsAccess';
import {usePermissions} from '@/hooks/usePermissions';
import {useHydrated} from '@/hooks/useHydrated';

interface NavigationItem {
    id: string;
    label: string;
    icon: typeof HouseIcon;
}

const baseNavigationItems: NavigationItem[] = [
    {id: 'dashboard', label: 'Dashboard', icon: HouseIcon},
    {id: 'linda', label: 'Linda', icon: ChatCircleDotsIcon},
    {id: 'products', label: 'Products', icon: ChairIcon},
    {id: 'groups', label: 'Groups', icon: LampIcon},
    {id: 'materials', label: 'Materials', icon: PaintRollerIcon},
    {id: 'floor-wall-materials', label: 'Floor & Wall', icon: WallIcon},
    {id: 'modular-systems', label: 'Configurators', icon: PuzzlePieceIcon},
];

export function Navigation(): React.ReactElement {
    const isHydrated = useHydrated();
    const hasMaterialsAccess = useMaterialsAccess();
    const {hasAccess} = usePermissions();

    // Render all items during SSR and initial hydration to avoid mismatch
    // After hydration, apply permission filtering
    const navigationItems = isHydrated
        ? baseNavigationItems.filter((item) => {
              if (item.id === 'materials' && !hasMaterialsAccess) return false;
              if (
                  item.id === 'floor-wall-materials' &&
                  !hasAccess('admin-only')
              )
                  return false;
              if (item.id === 'linda' && !hasAccess('linda-chatbots'))
                  return false;

              return true;
          })
        : baseNavigationItems;

    return (
        <nav className={styles.navigation}>
            {navigationItems.map((item) => (
                <NavItem
                    key={item.id}
                    id={item.id}
                    label={item.label}
                    icon={item.icon}
                />
            ))}
        </nav>
    );
}
